<template>
  <div class="w100 h100">
    <!-- 图片展示 -->
    <div class="image-container">
      <img :src="src" :alt="alt" class="preview-image">
      <i class="el-icon-zoom-in preview-icon" @click="openPreview"></i>
    </div>
    <!-- 预览模态框 -->
    <div v-if="showModal" class="preview-modal" @click.self="closePreview">
      <span class="close-btn" @click="closePreview">&times;</span>

      <!-- 上一张按钮 -->
      <div v-if="previewSrcList.length > 1" class="nav-btn prev-btn" @click="prevImage">
        <span class="arrow">&#x2039;</span>
      </div>

      <img :src="currentPreviewSrc" class="modal-image">

      <!-- 下一张按钮 -->
      <div v-if="previewSrcList.length > 1" class="nav-btn next-btn" @click="nextImage">
        <span class="arrow">&#x203A;</span>
      </div>

      <!-- 图片计数器 -->
      <div v-if="previewSrcList.length > 1" class="image-counter">
        {{ internalIndex + 1 }} / {{ previewSrcList.length }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    previewSrc: {
      type: String,
      default: ''
    },
    previewSrcList: {
      type: Array,
      default: () => []
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    listFields: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      currentPreviewSrc: '',
      internalIndex: this.currentIndex
    }
  },
  methods: {
    openPreview() {
      // 如果有预览图片列表，使用传入的索引或查找当前图片索引
      if (this.previewSrcList.length > 0) {
        if (this.currentIndex >= 0 && this.currentIndex < this.previewSrcList.length) {
          // 使用传入的索引
          this.internalIndex = this.currentIndex;
        } else {
          // 查找当前图片在列表中的索引
          const targetSrc = this.previewSrc || this.src;
          this.internalIndex = this.previewSrcList.findIndex(item => item === targetSrc);
          if (this.internalIndex === -1) {
            this.internalIndex = 0;
          }
        }
        let listFields = this.listFields;
        if(listFields){
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
        }else{
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
        }
      } else {
        // 如果没有预览图片列表，使用指定的预览图片或原图片
        this.currentPreviewSrc = this.previewSrc || this.src;
        this.internalIndex = 0;
      }

      this.showModal = true;
      document.body.style.overflow = 'hidden';
    },
    closePreview() {
      this.showModal = false;
      document.body.style.overflow = '';
    },
    prevImage() {
      if (this.previewSrcList.length > 0) {
        this.internalIndex = (this.internalIndex - 1 + this.previewSrcList.length) % this.previewSrcList.length;
        let listFields = this.listFields;
        if(listFields){
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
        }else{
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
        }
      }
    },
    nextImage() {
      if (this.previewSrcList.length > 0) {
        this.internalIndex = (this.internalIndex + 1) % this.previewSrcList.length;
        let listFields = this.listFields;
        if(listFields){
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex][listFields];
        }else{
          this.currentPreviewSrc = this.previewSrcList[this.internalIndex];
        }
      }
    },
    handleKeydown(e) {
      if (this.showModal) {
        switch (e.key) {
          case 'Escape':
            this.closePreview();
            break;
          case 'ArrowLeft':
            this.prevImage();
            break;
          case 'ArrowRight':
            this.nextImage();
            break;
        }
      }
    }
  },
  mounted() {
    // 添加键盘导航支持
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.preview-image {
  transition: all 0.3s;
  max-width: 100%;
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.preview-icon {
  position: absolute;
  bottom: 4px;
  right: 4px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
  padding: 4px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
}

.preview-icon:hover {
  color: rgba(255, 255, 255, 1);
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-image {
  max-width: 80%;
  height: 80vh;
  object-fit: contain;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  color: #fff;
  font-size: 40px !important;
  font-weight: bold;
  cursor: pointer;
  z-index: 10000;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ccc;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 40px !important;
  font-weight: bold;
  cursor: pointer;
  z-index: 10000;
  user-select: none;
  border-radius: 50%;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.nav-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-50%) scale(1.1);
}

.nav-btn:active {
  transform: translateY(-50%) scale(0.95);
}

.prev-btn {
  left: 30px;
}

.next-btn {
  right: 30px;
}

.image-counter {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 8px 16px;
  border-radius: 20px;
  z-index: 10000;
}

.arrow {
  display: inline-block;
  font-size: 40px !important;
  line-height: 1;
  transform: translateY(-6px) translateX(-2px);
}

.next-btn .arrow {
  transform: translateY(-6px) translateX(2px);
}
</style>